import React from 'react';
import Entry from '../components/Entry';
import EntryConfig from '../components/entryconfigType';
import '../Default.css';


const menuItems: EntryConfig[] = [
  {
    img:"/icons/person-falling-burst-solid.svg",
    img_alt: "accident",
    link: "/accident",
    text: "wypadek"
  },
  {
    img:"/icons/building-flag-solid.svg",
    img_alt: "embassy",
    link: "/embassy",
    text: "ambasada"
  },
  {
    img:"/icons/circle-down-solid.svg",
    img_alt: "links",
    link: "/links",
    text: "pobierz"
  },
  {
    img:"/icons/bus-solid.svg",
    img_alt: "transport",
    link: "/transport",
    text: "transport"
  },
  {
    img:"/icons/cloud-solid.svg",
    img_alt: "pogoda",
    link: "/weather",
    text: "pogoda"
  }
]

function Przydasie() {
    return (
      <>
        <div className="page-title">
          Przydasie
        </div>
        <div className="navigation-wraper">
          <nav className="navigation-bar">
            {menuItems.map((v,i) => <Entry conf={v} key={i}/>)}
          </nav>
        </div>
      </>
    );
}

export default Przydasie;